import { useEffect, useRef } from 'react';
import { isSettlementCalculating } from './ProviderSettlementDetails.Logic';

export const SETTLEMENT_POLLING_INTERVAL_MS = 5000;

/**
 * Generación asincrónica de la liquidación de proveedor (spec 010, DEC-APP-007): mientras el estado es Registrada (1)
 * o En curso (2) vuelve a pedir la liquidación cada 5 s (`refresh`); se detiene al cambiar de estado o al desmontar.
 * Cuando deja de calcularse (Finalizada, Falló…) llama a `onFinished` una vez, para pedir los detalles.
 */
export const useSettlementExecutionPolling = (
    settlementId: number | undefined,
    status: number | null | undefined,
    refresh: (settlementId: number) => void,
    onFinished: (settlementId: number) => void,
    intervalMs: number = SETTLEMENT_POLLING_INTERVAL_MS
): boolean => {
    const calculating = isSettlementCalculating(status);
    const wasCalculating = useRef<boolean>(false);
    // Callbacks en refs: connect() puede rehacer las funciones y no por eso hay que reiniciar el intervalo.
    const refreshRef = useRef(refresh);
    const finishedRef = useRef(onFinished);
    refreshRef.current = refresh;
    finishedRef.current = onFinished;

    useEffect(() => {
        if (!settlementId) return;
        if (!calculating) {
            if (wasCalculating.current && status !== undefined && status !== null) {
                wasCalculating.current = false;
                finishedRef.current(settlementId);
            }
            return;
        }
        wasCalculating.current = true;
        const timer = setInterval(() => refreshRef.current(settlementId), intervalMs);
        return () => clearInterval(timer);
    }, [settlementId, calculating, status, intervalMs]);

    return calculating;
};
